export interface CommentModel {
  key: string;
  id: number;
  name: string;
  email: string;
  phone: string;
  message: string;
  rating?: number;
  status: string;
  staffId?: number;
  parentId?: number;
  customerId?: number;
  referenceId: number;
  commentType: string;
  isActive: boolean;
  childrenComments: CommentModel[];
  creationTime: Date;
}

export interface CreatedCommentModel {
  message: string;
  parentId?: number;
  referenceId: number;
  commentType: string;
}

export interface SearchCommentRequestModel {
  active: boolean;
  status: string;
  referenceId: number;
  commentType: string;
}

export class CommentStatusConst
{
  public static readonly New = "New";
  public static readonly Done = "Done";
}
export class CommentTypeConst
{
  public static readonly ProductDetail = "ProductDetail";
  public static readonly ProductCate = "ProductCate";
  public static readonly BlogDetail = "BlogDetail";
  public static readonly StaticPage = "StaticPage";
}
